import React from 'react';
import { Filter } from 'react-admin';

import { ToggleTerminalsFilter, TERMINAL_ALL_VALUE } from '../../../components/filters/ToggleTerminalsFilter';


export const filterDefaultValues = {
	"terminal_id": [TERMINAL_ALL_VALUE],
};


export const PortAreaFilters = (props) => {
	return (
		<Filter {...props}>
			<ToggleTerminalsFilter source="terminal_id" defaultValue={null} alwaysOn key={"terminal_id"} />
		</Filter>
	);
};
